<template>
  <div class="form-toggle-switch-element-wrapper">
    <div class="d-flex align-items-center justify-content-between">
      <label
        class="form-label text-break"
        :style="labelStyle"
        :for="`switch-${element.id}`"
      >
        <div class="d-flex justify-content-between align-items-center gap-2">
          <div
            v-if="element?.settings?.prefixIcon?.icon"
            class="prefix-image-wrap overflow-hidden bg-transparent d-flex align-items-center justify-content-center"
          >
            <img
              class="prefix-icon object-fit-contain mh-100 mw-100"
              :src="element.settings.prefixIcon.icon"
              :id="`prefix-icon-${element.id}`"
              alt="prefix-icon"
            />
          </div>

          <span :id="`label-${element.id}`">
            {{ element.label }}
            <span v-if="showRequiredMark" class="required-star">*</span>
            <img
              v-if="isTooltipVisible"
              src="@/assets/img/info-icon.svg"
              class="tooltip-info-icon"
              v-tooltip="getTooltipConfig"
            />
          </span>
        </div>
      </label>
      <div class="switch-wrapper">
        <InputSwitch
          v-model="element.value"
          :elementId="element.id"
          :tabIndex="element?.settings?.tabindex"
          :brandedStyle="brandedStyle"
          :isDisabled="element?.settings?.disabled"
        />
      </div>
    </div>
    <p
      :id="`description-${element.id}`"
      class="description fw-normal text-break p-0"
      :style="labelStyle"
    >
      {{ element?.settings?.description }}
    </p>
  </div>
</template>

<script>
import InputSwitch from '@/components/FormBuilder/core/InputSwitch.vue';
export default {
  name: 'FormToggleSwitch',

  props: {
    element: {
      type: Object,
      required: true,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    labelStyle: { type: Object, default: () => {} },
    brandedStyle: { type: Object, default: () => {} },
  },
  computed: {
    showRequiredMark() {
      return (
        !!this.element?.settings?.required &&
        !this.element?.settings?.disabled &&
        String(this.element?.label || '').trim().length > 0
      );
    },
    isTooltipVisible() {
      return this.element?.settings?.tooltip?.trim()?.length > 0;
    },
    getTooltipConfig() {
      return {
        text: this.element.settings.tooltip,
        html: true,
        position: 'right',
        auto: true,
        offsetY: -38,
        offsetX: -8,
        tooltipClass: 'form-builder-label-tooltip',
        bgColor:
          this.brandedStyle?.primaryBrandColor &&
          this.brandedStyle?.primaryBrandColor !== ''
            ? this.brandedStyle?.primaryBrandColor
            : null,
        color:
          this.brandedStyle?.textColor && this.brandedStyle?.textColor !== ''
            ? this.brandedStyle?.textColor
            : null,
      };
    },
  },
  components: {
    InputSwitch,
  },
};
</script>

<style scoped>
.form-toggle-switch-element-wrapper .form-label {
  font-family: 'OpenSans-Bold';
  color: #000000;
  margin: 0px;
  line-height: 27px;
  letter-spacing: -0.02em;
  position: unset;
  font-weight: 600;
  font-size: 16px;
}
.form-toggle-switch-element-wrapper .prefix-image-wrap {
  width: 27px;
  height: 27px;
}
.form-toggle-switch-element-wrapper .prefix-icon {
  -webkit-user-drag: none;
}

.form-toggle-switch-element-wrapper .description {
  width: calc(100% - 60px);
  margin-bottom: 0px;
  margin-top: 9px;
  font-size: 14px;
  font-family: 'OpenSans-Regular';
  letter-spacing: -0.02em;
  color: #919191;
}
.form-toggle-switch-element-wrapper div:has(.prefix-icon) + .description {
  margin-left: calc(25px + 8px);
  width: calc(100% - 60px - 25px - 8px);
}

.form-toggle-switch-element-wrapper .switch-wrapper {
  height: 26px;
}

.form-toggle-switch-element-wrapper .tooltip-info-icon {
  margin-left: 2px;
  margin-top: -3px;
  cursor: pointer;
}
.form-toggle-switch-element-wrapper .required-star {
  color: #ff0000;
  margin-left: 4px;
  display: inline-block;
  line-height: 1;
  transform: scale(0.8);
  transform-origin: left center;
  vertical-align: baseline;
}
</style>
<style>
.form-builder-label-tooltip {
  padding: 7px 12px !important;
  font-family: 'OpenSans-regular' !important;
  font-weight: 400 !important;
  font-size: 10px !important;
  letter-spacing: -0.32px !important;
  text-align: left !important;
  max-width: 181px !important;
  background: #000 !important;
}
.form-builder-label-tooltip p {
  margin: 0 0 6px !important;
}
.form-builder-label-tooltip p:last-child {
  margin-bottom: 0 !important;
}
.form-builder-label-tooltip ul,
.form-builder-label-tooltip ol {
  margin: 4px 0 !important;
  padding-left: 18px !important;
}
.form-builder-label-tooltip strong,
.form-builder-label-tooltip b {
  font-family: 'OpenSans-Bold' !important;
}
</style>
